module.exports = __webpack_public_path__ + "images/patterns/light/StripeDiagonal.48c42842a8b8affda92b.svg";